import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from '../../../../shared/comum.module';
import { translateLoaderNBS } from '../../../../shared/translate-loader/translateLoader';
import { AnaliseHoraBi05FiltroComponent } from './analise-hora-bi05-filtro/analise-hora-bi05-filtro.component';
import { AnaliseHoraBi05ListaGridComponent } from './analise-hora-bi05-lista/analise-hora-bi05-lista-grid/analise-hora-bi05-lista-grid.component';
import { AnaliseHoraBi05ListaComponent } from './analise-hora-bi05-lista/analise-hora-bi05-lista.component';
import { AnaliseHoraBi05Service } from './analise-hora-bi05-service/analise-hora-bi05.service';
import { AnaliseHoraBi05Component } from './analise-hora-bi05.component';


@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    NgbModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    AnaliseHoraBi05Component,
    AnaliseHoraBi05ListaGridComponent
  ],
  declarations: [
    AnaliseHoraBi05Component,
    AnaliseHoraBi05ListaComponent,
    AnaliseHoraBi05FiltroComponent,
    AnaliseHoraBi05ListaGridComponent
  ],
  providers: [
    AnaliseHoraBi05Service
  ]
})
export class AnaliseHoraBi05Module { }
